import React from "react";
import { cn } from "../../utils/classnames";
import CountryCodePicker from "./input-register/CountryCodePicker";

/**
 * Phone number field in the newer 50px style (booking confirmation page):
 * country dial-code picker + number input drawn as one box.
 * Same picker as the registration forms (CountryCodePicker).
 */
const NewFormInputPhoneNumber = ({
    name,
    placeholder,
    value,
    onChange,
    disabled,
    isInvalid,
    invalidMessage,
    countryCode,
    prefixPhoneNumber,
    handleClickCountryList,
}) => {
    return (
        <div className="tw:w-full">
            <div
                className={cn(
                    "tw:flex tw:h-[50px] tw:items-stretch tw:rounded-md tw:border tw:bg-white tw:transition-[border-color,box-shadow] tw:duration-200",
                    "tw:focus-within:border-[#DBBE78] tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)]",
                    isInvalid ? "tw:border-[#E5484D]" : "tw:border-[#DADADA]"
                )}
            >
                <CountryCodePicker
                    countryCode={countryCode}
                    dialCode={prefixPhoneNumber}
                    onSelect={handleClickCountryList}
                    disabled={disabled}
                />
                <input
                    type="text"
                    name={name}
                    value={value ?? ""}
                    placeholder={placeholder}
                    disabled={disabled}
                    autoComplete="tel-national"
                    inputMode="tel"
                    // Passed through unchanged, as before: this field is not digits-only.
                    onChange={onChange}
                    className="tw:min-w-0 tw:flex-1 tw:rounded-r-md tw:bg-transparent tw:px-3 tw:text-[15px] tw:text-[#4E4E4E] tw:outline-none tw:placeholder:!text-[15px] tw:placeholder:!text-[#A7A7A7]"
                />
            </div>
            {isInvalid && <p className="text-danger">{invalidMessage}</p>}
        </div>
    );
};

export default NewFormInputPhoneNumber;
